

















































import { Component, Prop, Vue } from "vue-property-decorator";
import { RequestStatus } from "../utils/constans";
import { formatBackTime } from "../utils/common";
import { iPublication, iResearchArea } from "../typings/publication";
import $api from "../api";
import mockArea from '../mock/researchDirection';
import mockPublication from '../mock/puplication';

@Component
export default class CompPublication extends Vue {
  private pubList: iPublication[] = [];

  private areaList: iResearchArea[] = [];
  private enAreaList: iResearchArea[] = [];

  mounted() {
    this.getPublicationList();
    this.getResearchAreaList();
  }

  getPublicationList() {
    const succ = (res: any) => {
      (res as any).map((record: iPublication) => {
        if (this.pubList.length < 10) {
          this.pubList.push(record);
        }
      });
    };
    if (this.$store.state.offModel) {
      succ(mockPublication);
    } else {
      $api.publication.findAllPublicationClient().then(succ);
    }
  }

  getResearchAreaList() {
    const succ = (res: any) => {
      (res as any).map((record: iResearchArea) => {
        if (record.language === "英语") {
          this.enAreaList.push(record);
        } else if (record.language !== "英语") {
          this.areaList.push(record);
        }
      });
    }

    if (this.$store.state.offModel) {
      succ(mockArea);
    } else {
      $api.publication.findAllresearchAreasClient().then(succ);
    }
  }
}
